<template>
  <div class="-trend">
    <div class="c_main -pad-btm">
      <div class="inner">
        <nav class="c_pnkz">
          <ul class="c_pnkz_list">
            <li>
              <a class="c_pointer" @click="$router.push({ name: 'Home' })">
                ホーム
              </a>
            </li>
            <li>{{ contents.title }}</li>
          </ul>
        </nav>

        <pdf-single ref="pdf" :contents="contents"></pdf-single>

        <div class="detail">
          <p class="c_main_ttl">{{ contents.title }}</p>
          <p>{{ contents.description }}</p>
        </div>
        <div class="c_pageback">
          <a class="c_txtlink" @click="$router.push({ name: 'Home' })">
            トップに戻る
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PdfSingle from "@/components/PDFSingle";

export default {
  components: {
    PdfSingle
  },
  props: {
    id: {
      type: String
    },
    category: {
      type: String
    },
    routerName: {
      type: String
    }
  },
  data() {
    return {
      contents: {}
    };
  },
  created() {
    this.fetchContents();
  },
  methods: {
    fetchContents() {
      this.loadingContents = true;

      this.$authAxios
        .get(`/api/contents/${this.id}`)
        .then(response => {
          this.contents = response.data;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loadingContents = false;
          this.$refs.pdf.init();
        });
    }
  }
};
</script>

<style scoped>
.detail {
  margin-top: 60px;
}
.c_main_ttl {
  text-align: start;
}
</style>
